import GenericSubOffCanvas from "../../GenericSubOffCanvas/GenericSubOffCanvas";

export const MenuHogar = [
  "Hogar",
  "Accesorios para el Hogar",
  "Baño",
  "Blancos y Lavanderia",
  "Decoracion",
  "Electrodomesticos",
  "Ferreteria y Automotriz",
  "Lamparas",
  "Limpieza",
  "Organizacion y Almacenamiento",
];

export const MenuCocina = [
  "Cocina",
  "Accesorios de Cocina",
  "Almacenamiento de Cocina",
  "Articulos de Mesa",
  "Vasos, Termos y Cilindros",
];

export const MenuSalud = [
  "Salud y Belleza",
  "Accesorios de Belleza",
  "Cosmeticos",
  "Cuidado Corporal",
  "Cuidado del Cabello",
  "Cuidado Facial",
  "Farmacia e Higiene",
  "Mascarillas",
  "Perfumes y Lociones",
];

export const MenuPapeleria = [
  "Papeleria",
  "Accesorios de Papeleria",
  "Escritura",
  "Libretas y Cuadernos",
  "Manualidades",
  "Regalos",
];

export const MenuModa = [
  "Moda",
  "Accesorios de Moda",
  "Accesorios para el Cabello",
  "Bolsas y Mochilas",
  "Calzado",
  "Carteras y Monederos",
  "Joyeria",
  "Ropa",
];

export const MenuTecnologia = [
  "Tecnologia",
  "Accesorios de Tecnologia",
  "Audio y Video",
  "Cables",
  "Gadgets",
  "Telefonia",
];

export const MenuJuguetes = [
  "Juguetes",
  "Armables",
  "Didacticos",
  "Juegos Familiares",
  "Muñecos",
  "Peluches",
  "Vehiculos",
];

export const MenuViajes = ["Viajes", "Accesorios para Viaje", "Maletas"];

export const MenuDeportes = [
  "Deportes",
  "Accesorios Deportivos",
  "Ropa Deportiva",
];

export const MenuMascotas = [
  "Mascotas",
  "Accesorios",
  "Higiene",
  "Juguetes",
  "Platos y Tazones",
];

export const MenuSnacks = [
  "Snacks",
  "Chicles",
  "Chocolates",
  "Dulces",
  "Fruta Deshidratada",
  "Galletas",
  "Papas y Palomitas",
  "Semillas",
  "Té en Polvo",
];

export const MenuLicencias = [
  "Coca-Cola",
  "Disney",
  "Fruit Series",
  "We Bear Bears",
  "Minions",
  "Snoopy",
  "Tom y Jerry",
  "Xico",
];

export const MenuCategories = [
  "Categorias",
  <GenericSubOffCanvas subMenu={MenuHogar}/>,
  <GenericSubOffCanvas subMenu={MenuCocina}/>,
  <GenericSubOffCanvas subMenu={MenuSalud}/>,
  <GenericSubOffCanvas subMenu={MenuPapeleria}/>,
  <GenericSubOffCanvas subMenu={MenuModa}/>,
  <GenericSubOffCanvas subMenu={MenuTecnologia}/>,
  <GenericSubOffCanvas subMenu={MenuJuguetes}/>,
  <GenericSubOffCanvas subMenu={MenuViajes}/>,
  <GenericSubOffCanvas subMenu={MenuDeportes}/>,
  <GenericSubOffCanvas subMenu={MenuMascotas}/>,
  <GenericSubOffCanvas subMenu={MenuSnacks}/>,
];
